import { IonBackButton, IonButtons, IonContent, IonHeader, IonLabel, IonPage, IonSegment, IonSegmentButton, IonTitle, IonToolbar, SegmentValue } from "@ionic/react";
import { useTranslation } from "react-i18next";
import "./news.css";
import { useState } from "react";
import NewsList from "../../components/newsList";
import { CommunicationType } from "../../apollo-client/types";

const News: React.FC = () => {
  const {t} = useTranslation();
  const [selectedSegmentValue, setSelectedSegmentValue] = useState<SegmentValue | undefined>("all");
  const [selectedCommunicationType, setSelectedCommunicationType] = useState<CommunicationType>();
  const onChangeSelectedSegmentValue = (value: SegmentValue | undefined): void => {
    setSelectedSegmentValue(value);
    switch (value?.toString()) {
      case "news":
        setSelectedCommunicationType(CommunicationType.FREETEXT);
        break;
      case "discounts":
        setSelectedCommunicationType(CommunicationType.DISCOUNT);
        break;
      default:
        setSelectedCommunicationType(undefined);
        break;
    };
  };
  return (
    <IonPage className="mainSelection">
      <IonHeader>
        <IonToolbar color="secondary">
          <IonButtons slot="start">
            <IonBackButton />
          </IonButtons>
          <IonTitle>{t("news.title")}</IonTitle>
        </IonToolbar>
        <IonSegment mode="ios" className="news-segment" value={selectedSegmentValue} onIonChange={(e) => onChangeSelectedSegmentValue(e.detail.value)}>
          <IonSegmentButton value="all">
            <IonLabel>{t("news.all_communications")}</IonLabel>
          </IonSegmentButton>
          <IonSegmentButton value="news">
            <IonLabel>{t("news.only_news")}</IonLabel>
          </IonSegmentButton>
          <IonSegmentButton value="discounts">
            <IonLabel>{t("news.only_discounts")}</IonLabel>
          </IonSegmentButton>
        </IonSegment>
      </IonHeader>
      <IonContent fullscreen className="pageContainer">
        {!selectedCommunicationType && (<NewsList />)}
        {selectedCommunicationType === CommunicationType.FREETEXT && (<NewsList selectedCommunicationType={selectedCommunicationType} />)}
        {selectedCommunicationType === CommunicationType.DISCOUNT && (<NewsList selectedCommunicationType={selectedCommunicationType} />)}
      </IonContent>
    </IonPage>
  );
};

export default News;
